import { InjectionToken } from '@angular/core';

export interface StorageManager<T = void> {
  persist(key: string, value: unknown): Promise<void>;
  retrieve<T>(key: string): Promise<T | null>;
  remove(key: string): Promise<void>;
  clearStorage(): Promise<void>;
}

export const STORAGE_MANAGER_TOKEN = new InjectionToken<StorageManager>(
  'app.storage',
);
